// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Reviews/index.css
// module id = 2614
// module chunks = 0